import Alpine from 'alpinejs'

Alpine.store('ServiceMenu', {
  isOpen: false,

  open() {
    this.isOpen = true
  },

  close() {
    this.isOpen = false
  },
})
